import {Regulation} from 'types';
import {createRegulationHref} from '../regulationLinks.utils';

export const createHrefFromRegulation = (
	regulationWithoutType: unknown,
): string => {
	const regulation = regulationWithoutType as Regulation;
	return createRegulationHref(regulation.id);
};
